import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { selectArtists } from 'services/store/user/selectors';
import { StyledButton, StyledContainer, StyledTypography } from './styled';

const ARTISTS_LIMIT = 3;

const ArtistCounter = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { releaseId } = useParams();
  const artists = useSelector(selectArtists);
  const artistAmount = artists.length;

  const handleAddArtist = () => {
    if (!releaseId) {
      return;
    }
    return navigate(locations.distribution.artistName.pathname(releaseId));
  };
  const isDisabled = artistAmount === ARTISTS_LIMIT;

  return (
    <StyledContainer>
      <StyledTypography>
        <Trans i18nKey="distribution:artistName:artistAmount">
          {{ artistAmount }}
          {{ totalAmount: ARTISTS_LIMIT }}
        </Trans>
      </StyledTypography>

      <StyledButton
        variant="plainText"
        onClick={handleAddArtist}
        disabled={isDisabled}
      >
        {t('distribution:artistName:createNewArtist')}
      </StyledButton>
    </StyledContainer>
  );
};

export default ArtistCounter;
